export default __webpack_public_path__ + "static/media/esg-68.95bfcd78.jpg";